// @ts-check

const SUPPORTED_OPERATORS = new Set(['==', '!=', '<', '<=', '>', '>=', 'contains']);
const SUPPORTED_COMBINERS = new Set(['all', 'any', 'none']);

/**
 * Convert PointsController.appliedFilters into the wire format expected by
 * the Rails `_dashboard_storage_facilities` export endpoint.
 *
 * Input shape (from PointsController):
 *   { 'management_type@1': { value: 'REIT', filterType: '==' }, ... }
 * Output shape:
 *   { management_type: { op: '==', value: 'REIT' }, ... }
 *
 * Property keys are normalized: a trailing `@N` (used to disambiguate
 * duplicate criteria entries client-side) is stripped so the backend sees
 * raw `selfstorage_facility` column names.
 *
 * @param {Record<string, { value: any, filterType: string }>} appliedFilters
 * @returns {Record<string, { op: string, value: any }>}
 */
export function serializeAppliedFiltersForExport(appliedFilters) {
    const out = {};
    if (!appliedFilters) return out;
    Object.keys(appliedFilters).forEach(key => {
        const rule = appliedFilters[key];
        if (!rule || rule.value == null || rule.value === '') return;
        if (!SUPPORTED_OPERATORS.has(rule.filterType)) return;
        const column = key.replace(/@\d+$/, '');
        out[column] = { op: rule.filterType, value: rule.value };
    });
    return out;
}

/**
 * @param {string} combinerType  PointsController.filterCombinerType — 'all' | 'any' | 'none'
 * @returns {string}
 */
export function serializeCombinerForExport(combinerType) {
    return SUPPORTED_COMBINERS.has(combinerType) ? combinerType : 'all';
}
